import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { ILoginResult } from '../types/user';
import { environment } from '../config/environment';
import axiosInstance from './axiosConfig';

class AuthService {
  private currentUserKey = 'currentUser';

  getCurrentUser(): ILoginResult | null {
    const userStr = localStorage.getItem(this.currentUserKey);
    return userStr ? JSON.parse(userStr) : null;
  }

  isTokenExpired(token: string): boolean {
    try {
      const decoded: any = jwtDecode(token);
      if (!decoded.exp) return true;
      const expirationDate = new Date(decoded.exp * 1000);
      return expirationDate < new Date();
    } catch {
      return true;
    }
  }

  isUserLoggedIn(): boolean {
    const currentUser = this.getCurrentUser();
    if (currentUser != null) {
      if (!this.isTokenExpired(currentUser.token)) {
        return !(currentUser.setupTfa || currentUser.requestTfaCode);
      } else {
        console.log('isUserLoggedIn Token expired');
        this.logout();
        return false;
      }
    }
    return false;
  }

  hasRole(roles: string[]): boolean {
    const currentUser = this.getCurrentUser();
    if (currentUser != null) {
      for (const role of roles) {
        if (currentUser.roles.indexOf(role) >= 0) {
          return true;
        }
      }
    }
    return false;
  }

  getNotificationsAllowedAccounts(): string[] | undefined {
    const currentUser = this.getCurrentUser();
    return currentUser?.notificationsAllowedAccounts;
  }

  async login(username: string, password: string): Promise<ILoginResult> {
    const response = await axios.post<ILoginResult>(
      `${environment.apiUrl}login`,
      { username, password }
    );
    const user = response.data;
    localStorage.setItem(this.currentUserKey, JSON.stringify(user));
    return user;
  }

  async setupTfa(tfaCode: string): Promise<ILoginResult> {
    const response = await axiosInstance.post<ILoginResult>(
      `${environment.apiUrl}tfa/bind`,
      { tfaCode }
    );
    const user = response.data;
    localStorage.setItem(this.currentUserKey, JSON.stringify(user));
    return user;
  }

  async validateTfa(tfaCode: string): Promise<ILoginResult> {
    const response = await axiosInstance.post<ILoginResult>(
      `${environment.apiUrl}tfa/validate`,
      { tfaCode }
    );
    const user = response.data;
    localStorage.setItem(this.currentUserKey, JSON.stringify(user));
    return user;
  }

  logout(): void {
    localStorage.removeItem(this.currentUserKey);
  }
}

export const authService = new AuthService();
